/**
 * Basic validation for Google review URLs pasted from Google Business Profile.
 */
export function validateGoogleReviewUrl(url) {
  const trimmed = String(url || '').trim();
  if (!trimmed) {
    return { valid: false, error: 'Google review link is required when reviews are enabled.' };
  }

  let parsed;
  try {
    parsed = new URL(trimmed);
  } catch {
    return { valid: false, error: 'Please enter a valid URL (must start with https://).' };
  }

  if (parsed.protocol !== 'https:') {
    return { valid: false, error: 'Review link must use https://.' };
  }

  const host = parsed.hostname.toLowerCase();
  const allowedHosts = [
    'g.page',
    'maps.google.com',
    'www.google.com',
    'google.com',
    'search.google.com',
  ];
  const hostOk =
    allowedHosts.some((h) => host === h || host.endsWith(`.${h}`)) ||
    host.endsWith('.google.com') ||
    host.endsWith('.g.page');

  if (!hostOk) {
    return {
      valid: false,
      error: 'Link should come from Google (e.g. g.page/r/.../review or Google Maps).',
    };
  }

  return { valid: true, normalized: trimmed };
}
